export enum FractionationTypes {
  M = 1,
  T = 2,
  A = 3,
}
